<template>
    <fragment>
        <!-- <div
      class="absolute inset-y-0 right-0 bg-blue-600 rounded-full w-96 h-128 "
    >
      himf
    </div> -->
        <div
            id="home"
            class="relative pt-6 pb-3 sm:pb-4 md:pb-6 lg:pb-10 xl:pb-12"
        >
            <Header />
            <Hero />
        </div>
    </fragment>
</template>

<script>
import Header from "../components/header";
import Hero from "../components/hero";

export default {
    name: "Home",
    components: { Header, Hero }
};
</script>
